import { createAction } from "@reduxjs/toolkit";
import { IMapOrder } from "@shared/components/Map/models/models";
import { IFullOrderDto } from "@shared/services/orders/dtos/orders/fullOrderDto";

export const orderDeleted = createAction<number>("orderDeleted");

export const orderUpdated = createAction<IFullOrderDto>("orderUpdated");

export const orderGrouped = createAction<IMapOrder[][]>("orderGrouped");
